export function CustomPopover() {

    let templateEngine = new ko.nativeTemplateEngine();

    ko.bindingHandlers.customPopover = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var placement = allBindings.get("placement") || "top",
                trigger = allBindings.get("trigger") || "click",
                templateName = allBindings.get("customPopover") || null,
                $element = $(element);

            let template = '<div class="popover px-1" role="tooltip" style="width: 500px;">';
            template += '<div class="arrow"></div><h3 class="popover-title"></h3>';
            template += '<div class="popover-content mx-1"><div class="data-content"></div></div></div>';

            $element.popover({
                placement: placement,
                trigger: trigger,
                html: true,
                content: "&nbsp;",
                template: template
            });

            $element.on("inserted.bs.popover", function () {
                var container = $(".popover")[0];

                if (templateName) {

                    ko.renderTemplate(templateName, viewModel, { templateEngine: templateEngine }, container);
                }
                else {
                    container.innerHTML = $element.attr("data-content");
                }
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $element.popover("dispose");
            });
        }
    };
}